module.exports = __webpack_public_path__ + "static/img/06.86c11ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/11/06.jpg
// module id = Oo8G
// module chunks = 2